module.exports = __webpack_public_path__ + "static/img/image-people.958056e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image-people.png
// module id = Fvop
// module chunks = 0